import React from "react";
import circle from '../../../assets/img/circulogris.png';
import Button from "../../../utils/components/Button/Button";
import Options from "../../../utils/components/Options/Options";
import { useHistory } from "react-router-dom";
import "./CardList.css";
import { checkMemberInZone } from "../../../actions/userActions";
import { useDispatch, useSelector } from "react-redux";

const CartListZone = ({
  //options = [],
  picture = '',
  textOne,
  textTwo,
  key = '',
  _id,
  onClick = () => { }
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { inCommunity } = useSelector(state => state.userInfo)

  return (
    <div key={_id} className="content-card-list-zone">
      {/* <Options options={options} /> */}
      <div className="content-img-card-list-zone" onClick={onClick}>
        <img alt="img" className="img-content-card-list-zone" onError={(e) => e.target.src = circle} src={picture}></img>
      </div>
      <div className="content-name-card-list-zone scroll-menu" onClick={onClick}>
        <div className="content-text-card-list-zone">
          <div className="text-one-card-list-zone">
            {textOne}
          </div>

        </div>
        <div className="text-two-card-list-zone">
          <Button onClick={() => {
               history.push(`/Zones/Zone/${_id}`)
            //
          }} classNameContent="text-two-card-list-zone" theme="white" text="Ingresar" />
        </div>
      </div>
    </div>
  );
};

export default CartListZone;
